module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/pdf.worker.7a74fa534bff8739c690.worker.js");
}
